<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id?'修改代理分销配置' :'新增代理分销配置'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="课程选择"
          prop="courseId"
        >
          <el-select
            v-model="createForm.courseId"
            placeholder="请选择课程"
            filterable
            clearable
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="课程总金额"
        >
          {{ totalPrice }}
        </el-form-item>
        <el-form-item
          label="代理分销总金额"
        >
          {{ totalAgentPrice }}
        </el-form-item>
        <el-form-item
          label="指定机构"
          prop="agencyId"
        >
          <el-select
            v-model="createForm.agencyId"
            placeholder="请选择机构"
            filterable
            clearable
          >
            <el-option
              v-for="course in agencyList"
              :key="course.id"
              :label="course.value"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="机构分销金额"
          prop="agencyDistributionAmount"
        >
          <el-input
            v-model="createForm.agencyDistributionAmount"
            class="append-unit"
          >
            <template
              slot="append"
            >
              元
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="代理商商分销"
        >
          {{ agentDistributionAmount + '元' }}
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            v-model="createForm.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      cancelText: '取消',
      courseList: [],
      agencyList: [],
      createForm: {
        id: '',
        agentId: this.$route.params.id,
        courseId: '',
        agencyId: -1,
        agentDistributionAmount: '',
        agencyDistributionAmount: '',
        remark: '',
      },
      creatRules: {
        courseId: [
          { required: true, message: '请选择代理课程', trigger: 'blur' },
        ],
        agencyDistributionAmount: [
          {
            required: true, message: '请输入平台分销金额', trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    totalPrice() {
      if (this.courseList.filter((v) => v.id === this.createForm.courseId).length > 0) {
        return `${this.courseList.filter((v) => v.id === this.createForm.courseId)[0].coursePrice / 100}元`;
      }
      return '0元';
    },
    totalAgentPrice() {
      if (this.courseList.filter((v) => v.id === this.createForm.courseId).length > 0) {
        return `${this.courseList.filter((v) => v.id === this.createForm.courseId)[0].agentDistributionAmount / 100}元`;
      }
      return '0元';
    },
    agentDistributionAmount() {
      if (this.courseList.filter((v) => v.id === this.createForm.courseId).length > 0) {
        return (this.courseList.filter((v) => v.id === this.createForm.courseId)[0].agentDistributionAmount - this.createForm.agencyDistributionAmount * 100) / 100;
      }
      return 0;
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.getCourseList();
        if (val) {
          console.log(this.createForm);
          this.$nextTick(() => {
            if (this.item) {
              const {
                id,
                courseId,
                agencyId,
                agentDistributionAmount,
                agencyDistributionAmount,
                remark,
              } = this.item;
              this.createForm = {
                id,
                agentId: this.$route.params.id,
                courseId,
                agencyId,
                agentDistributionAmount: agentDistributionAmount / 100,
                agencyDistributionAmount: agencyDistributionAmount / 100,
                remark,
              };
            } else {
              this.createForm.id = null;
            }
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.$refs.createForm.clearValidate();
      this.$refs.createForm.resetFields();
      this.$emit('update:dialogVisible', false);
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.agentDistributionAmount = this.agentDistributionAmount * 100;
          this.createForm.agencyDistributionAmount *= 100;
          const data = await axClient.agent.agentCourseAgencyUpsert(this.createForm);
          if (data) {
            if (this.createForm.id) {
              this.$message.success('修改代理商分销配置成功');
            } else {
              this.$message.success('新增代理商分销配置成功');
            }
            this.close();
            this.$emit('confirm');
          } else {
            this.createForm.agencyDistributionAmount /= 100;
          }
        }
      });
    },
    // 查询课程列表
    async getCourseList() {
      this.agencyList = [];
      this.courseList = [];
      this.courseList = await axClient.agent.agentCourseListAgentCourse(
        {
          id: this.$route.params.id,
        },
      );
      this.agencyList = await axClient.agent.listNameByAgent({
        id: this.$route.params.id,
      });
      this.agencyList = [{
        id: -1,
        value: '默认配置',
      }, ...this.agencyList];
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
}

</style>
